module.exports = __webpack_public_path__ + "ah.no1.7883a4d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ah.no1.jpg
// module id = J0pa
// module chunks = 0